import React from 'react';
import RenderInput from "../TrafficSource/RenderInput";
import { setConfigType } from "../../utils/configUtils";
const ConfigRenderInputs = ({ fieldType, editProps, data, disabled = false, defaultCategory }) => {
    switch (fieldType) {
        case 'category':
            return (
                <RenderInput
                    item={{
                        label: "Category",
                        key: "category",
                        type: "autoComplete",
                        required: true,
                        val: defaultCategory || 'allConfigCategory',
                        returnKey: 'name',
                        displayKey: 'name',
                        options: data.allConfigCategory.enumValues.filter((it) => it.name !== 'CAPACITY')
                    }}
                    disabled={disabled}
                    value={editProps.value || ''}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        case 'type':
            return (
                <RenderInput
                    item={{
                        label: "Select Category to set Type",
                        key: "type",
                        type: "text",
                        required: false,
                        val: 'allConfigType',
                        returnKey: 'name',
                        displayKey: 'name'
                    }}
                    disabled={true}
                    value={setConfigType(editProps.rowData.category) || ''}
                    data={data}
                    handleFilterChange={value => {
                        editProps.onChange(value);
                    }}
                />
            );
        default:
            return (
                <RenderInput
                    item={{
                        label: "Key",
                        key: 'key',
                        type: 'text',
                        required: true
                    }}
                    value={editProps.value || ''}
                    data={data}
                    disabled={disabled}
                    handleInputChange={e => editProps.onChange(e.target.value)}
                />
            );
    }
};

export default ConfigRenderInputs;
